export default __webpack_public_path__ + "static/media/Pyramid.fc4505d6.obj";